
const util = [
  {
    path: '/app/downloads',
    name: '',
    component: () => import(/* webpackChunkName: "store" */ '@/views/app/downloads'),
    meta: { title: '骑手端app下载', keepAlive: false }
  }
]

export default util
